<div
  class="subscription-card-container"
  [class.selected]="isSelectedPlan"
  [class.preview]="isPreview"
>
  <h2 class="title">{{ plan.name | translate }}</h2>
  <ul class="features">
    <li class="feature-row">
      <span class="icon-check">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="#53FBB4" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.54883 9.80586L8.43376 13.4991L14.6756 5.45459"
            fill="#53FBB4"
          />
          <path
            d="M4.54883 9.80586L8.43376 13.4991L14.6756 5.45459"
            stroke="black"
          />
        </svg>
      </span>
      <span class="feature-main"
        ><b
          >{{ 'OPS_SUBSCRIPTION_CARD.ACTIVE_PROJECTS' | translate }}:
          {{ plan.limitations?.maxRealProjectsInCompany }}</b
        ></span
      >
      <span
        class="icon-info"
        (mouseenter)="setIconInfoVisibleActiveProjects(true)"
        (mouseleave)="setIconInfoVisibleActiveProjects(false)"
      >
        <ops-info-tooltip
          (onEnter)="setIconInfoVisibleActiveProjects(true)"
          (onLeave)="setIconInfoVisibleActiveProjects(false)"
          [tooltipVisible]="iconInfoVisibleActiveProjects"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              *ngIf="iconInfoVisibleActiveProjects"
              cx="10"
              cy="10"
              r="10"
              fill="#D2FFF3"
            />
            <circle
              *ngIf="!iconInfoVisibleActiveProjects"
              cx="10"
              cy="10"
              r="10"
              fill="#747EFA"
              fill-opacity="0.22"
            />
            <path
              d="M9.22159 14.5V7.40909H10.3111V14.5H9.22159ZM9.77557 6.22727C9.56321 6.22727 9.38009 6.15495 9.22621 6.0103C9.0754 5.86565 9 5.69176 9 5.48864C9 5.28551 9.38009 5.11162 9.22621 4.96697C9.38009 4.82232 9.56321 4.75 9.77557 4.75C9.98793 4.75 10.1695 4.82232 10.3203 4.96697C10.4742 5.11162 10.5511 5.28551 10.5511 5.48864C10.5511 5.69176 10.4742 5.86565 10.3203 6.0103C10.1695 6.15495 9.98793 6.22727 9.77557 6.22727Z"
              fill="black"
            />
          </svg>
          <span tooltip-content>{{
            'OPS_SUBSCRIPTION_CARD.PROJECT_TOOLTIP' | translate
          }}</span>
        </ops-info-tooltip>
      </span>
    </li>
    <li class="feature-row sub-feature">
      <!-- <span class="icon-plus">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#00A8FF" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          
      </span> -->
      <span class="icon-check">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="#53FBB4" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.54883 9.80586L8.43376 13.4991L14.6756 5.45459"
            fill="#53FBB4"
          />
          <path
            d="M4.54883 9.80586L8.43376 13.4991L14.6756 5.45459"
            stroke="black"
          />
        </svg>
      </span>
      <span class="feature-main" *ngIf="!showMonthly"
        >{{ 'OPS_SUBSCRIPTION_CARD.EXTRA_PROJECT' | translate }}
        {{ currencyExchangeSymbol
        }}{{ priceForYear?.addOnPrices?.[0]?.price | number : '.0-0' }}</span
      >
      <span class="feature-main" *ngIf="showMonthly"
        >{{ 'OPS_SUBSCRIPTION_CARD.EXTRA_PROJECT' | translate }}
        {{ currencyExchangeSymbol
        }}{{ priceForMonth?.addOnPrices?.[0]?.price | number : '.0-0' }}</span
      >
      <span
        class="icon-info"
        (mouseenter)="setIconInfoVisibleAddOns(true)"
        (mouseleave)="setIconInfoVisibleAddOns(false)"
      >
        <!-- (mouseleave)="iconInfoVisibleAddOns = false" -->
        <ops-info-tooltip
          (onEnter)="setIconInfoVisibleAddOns(true)"
          (onLeave)="setIconInfoVisibleAddOns(false)"
          [tooltipVisible]="iconInfoVisibleAddOns"
          [tooltipBottom]="true"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              *ngIf="iconInfoVisibleAddOns"
              cx="10"
              cy="10"
              r="10"
              fill="#D2FFF3"
            />
            <circle
              *ngIf="!iconInfoVisibleAddOns"
              cx="10"
              cy="10"
              r="10"
              fill="#747EFA"
              fill-opacity="0.22"
            />
            <path
              d="M9.22159 14.5V7.40909H10.3111V14.5H9.22159ZM9.77557 6.22727C9.56321 6.22727 9.38009 6.15495 9.22621 6.0103C9.0754 5.86565 9 5.69176 9 5.48864C9 5.28551 9.38009 5.11162 9.22621 4.96697C9.38009 4.82232 9.56321 4.75 9.77557 4.75C9.98793 4.75 10.1695 4.82232 10.3203 4.96697C10.4742 5.11162 10.5511 5.28551 10.5511 5.48864C10.5511 5.69176 10.4742 5.86565 10.3203 6.0103C10.1695 6.15495 9.98793 6.22727 9.77557 6.22727Z"
              fill="black"
            />
          </svg>
          <span tooltip-content>
            {{ 'OPS_SUBSCRIPTION_CARD.ADD_ONS_TOOLTIP' | translate }}
          </span>
        </ops-info-tooltip>
      </span>
    </li>
    <li class="feature-row">
      <span class="icon-check">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="#53FBB4" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.54883 9.80586L8.43376 13.4991L14.6756 5.45459"
            fill="#53FBB4"
          />
          <path
            d="M4.54883 9.80586L8.43376 13.4991L14.6756 5.45459"
            stroke="black"
          />
        </svg>
      </span>
      <span class="feature-main"
        ><b>{{ 'OPS_SUBSCRIPTION_CARD.UNLIMITED_USERS' | translate }}</b></span
      >
    </li>
  </ul>

  <div class="price-section">
    <div class="price-section-inner">
      <span class="old-price" *ngIf="!showMonthly"
        >{{ currencyExchangeSymbol
        }}{{ priceForMonth?.price | number : '.0-0' }}</span
      >
      <span class="arrow" *ngIf="!showMonthly">→</span>
      <span class="new-price" *ngIf="!showMonthly"
        >{{ currencyExchangeSymbol
        }}{{ priceForMonthYearly | number : '.0-0' }}</span
      >
      <span class="new-price" *ngIf="showMonthly"
        >{{ currencyExchangeSymbol
        }}{{ priceForMonth?.price | number : '.0-0' }}</span
      >
    </div>
    <div class="billing-period">
      {{ 'OPS_SUBSCRIPTION_CARD.PER_MONTH' | translate
      }}{{
        !showMonthly
          ? ', ' + ('OPS_SUBSCRIPTION_CARD.BILLED_YEARLY' | translate)
          : ''
      }}
    </div>
  </div>

  <button
    class="btn-yellow"
    [disabled]="isDisabled && !isCreatingPlan"
    (click)="onSelectPlan()"
  >
    {{
      isSelectedPlan && !isCreatingPlan
        ? ('OPS_SUBSCRIPTION_CARD.CURRENT_PLAN' | translate)
        : ('OPS_SUBSCRIPTION_CARD.GET_PLAN' | translate) + ' ' + (plan.name.split(' ')[0] | translate) + ' ' + ('OPS_SUBSCRIPTION_CARD.PLAN' | translate)+ '!'
    }}
  </button>
</div>
